export const getNotUniqFunnelMessage = (funnel) => `Funnel ${funnel} already exists`;
export const getNotUniqUserMessage = (user) => `User ${user} already exists`;
export const getNotUniqGroupMessage = (group) => `Group ${group} already exists`;
